import Restful from '../utils/restful.js'
import http from '../utils/http.js'
const project = 'sci/'

const vissue = new Restful(project, 'vissue')
vissue.getForthcoming = function(data) {
  const url = project + 'vissue/forthcoming'
  return http.get(url, data).then(res => {
    return res
  })
}

vissue.updateForthcoming = function(data) {
  const url = project + 'vissue/forthcoming'
  return http.put(url, data).then(res => {
    return res
  })
}

vissue.getArticle = function(id, data) {
  const url = project + `vissue/${id}/article`
  return http.get(url, data).then(res => {
    return res
  })
}

vissue.export = (id, data) => {
  const url = project + 'vissue/' + id + '/article/export'
  return http.octetget(url, data).then(res => {
    res.url = window.URL.createObjectURL(res.file)
    return res
  })
}

const volume = new Restful(project, 'volume')
volume.getCode = function(data) {
  const url = project + 'volume/code'
  return http.get(url, data).then(res => {
    return res
  })
}

volume.Prepublisher = function(data) {
  const url = project + 'volume/pre/publisher'
  return http.put(url, data).then(res => {
    return res
  })
}

const issue = new Restful(project, 'issue')
export { vissue, issue, volume }
